export default [
    {
        id: 'static-home-section',
        icon: 'wallet',
        title: 'Home'
    },
    {
        id: 'static-api-endpoints-section',
        icon: 'card-manage',
        title: 'API Endpoints & Authentication'
    }
];


